import { render } from "./ResearchOfficerDetail.vue?vue&type=template&id=0489ee1b"
import script from "./ResearchOfficerDetail.vue?vue&type=script&lang=js"
export * from "./ResearchOfficerDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__